import { mapMutations } from 'vuex';
import clientAddressPopup from './../../components/clientAddressPopup/clientAddressPopup.vue';

export default {
  props: {
    client: {
      required: true,
      type: Object,
    },
    billId: {
      type: [String, Number],
      required: false,
    },
    currentEdiOrder: {
      required: false,
      type: Object,
    },
  },

  data() {
    return {
      currentClient: null,
      isBillAddressMissing: false,
      isBillEdit: false,
      billAddress: '',
    };
  },

  created() {
    this.currentClient = this.client;
    if (this.$route.name === 'bills.edit' || this.$route.name === 'bills.creditNote') {
      this.isBillEdit = true;
      this.billAddress = this.currentClient.billAddressData.billAddress;
      this.isBillAddressMissing = this.currentClient.billAddressData.billAddresMissing;
    }
  },

  computed: {
    /*
     * Displays the current client name.
     */
    clientName() {
      return this.currentClient.companyName || `${this.currentClient.firstName}
      ${this.currentClient.lastName}`;
    },

    /*
     * Displays the current client address.
     */
    clientAddress() {
      return `${this.currentClient.streetName},
      ${this.currentClient.postalCode}
      ${this.currentClient.cityName}, Norway`;
    },

    /*
     * Displays the current client phone.
     */
    clientPhone() {
      return (this.currentClient.mobileNumber || this.currentClient.phoneNumber) ? this.currentClient.mobileNumber || this.currentClient.phoneNumber : '-';
    },

    /*
     * Displays the current client email.
     */
    clientEmail() {
      return (this.currentClient.email) ? this.currentClient.email : '-';
    },

    /*
     * Check if bill address is missing.
     */
    billingAddressMissing() {
      return this.isBillAddressMissing;
    },

    /*
     * Bill address.
     */
    displayBillAddress() {
      let address = '';
      if (this.billAddress) {
        if (this.billAddress.street_name) {
          address += this.billAddress.street_name;
        }

        if (this.billAddress.second_street_name) {
          address += ', ' + this.billAddress.second_street_name;
        }

        if (this.billAddress.postal) {
          if (this.billAddress.postal.postal_code) {
            address += ', ' + this.billAddress.postal.postal_code;
          }

          if (this.billAddress.postal.city) {
            if (this.billAddress.postal.city.name) {
              address += ', ' + this.billAddress.postal.city.name;
            }

            if (this.billAddress.postal.city.country) {
              if (this.billAddress.postal.city.country.name) {
                address += ', ' + this.billAddress.postal.city.country.name;
              }
            }
          }
        }
      }

      return address;
    }
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalClass: 'SET_MODAL_CLASS',
    }),

    editClientAddress() {
      this.setModalContent(() => clientAddressPopup);
      this.setModalShowClose(true);
      this.setModalProps({
        billId: this.billId,
        clientId: this.client.id,
        onClose: this.handleClientAddressSave,
      });
      this.toggleModal(true);
    },

    handleClientAddressSave(client) {
      this.currentClient = client;
    },
  },

  components: {},
};



// WEBPACK FOOTER //
// ./src/app/components/clientInfo/clientInfo.js